//useCallback
export const formatSeries = (series: string = "") => {
  const abbreviations = ["IPO"]; // Add more abbreviations if needed

  return series
    .split(" ")
    .map(word => {
      const upperWord = word.toUpperCase();
      // if it's an abbreviation (like IPO)
      if (abbreviations.includes(upperWord)) return upperWord;
      // else capitalize first letter
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export const getFirstName = (name: string | undefined): string => {
  if (!name) return '';
  return name.split(' ')[0];
}